export default __webpack_public_path__ + "80088a20bf4367932f0968568fafcb51.svg";